export const FORM_FIELDS = {
  FIRST_NAME: {
    name: 'firstName',
    placeholder: 'First name',
    rules: [{ required: true, message: 'First name is required' }],
  },
  LAST_NAME: {
    name: 'lastName',
    placeholder: 'Last name',
    rules: [{ required: true, message: 'Last name is required' }],
  },
  PREMIUM: {
    name: 'isPremium',
  },
  EMAIL: {
    name: 'email',
    label: 'Email address:',
    placeholder: 'Enter an email address',
    rules: [
      { required: true, message: 'Email is required' },
      { type: 'email', message: "Doesn't look like an email" },
    ],
  },
  COMPANY: {
    name: 'organisation',
    placeholder: 'Email company name',
    rules: [{ required: true, message: 'Company name is required' }],
  },
  EVENT_ID: {
    name: 'eventId',
    placeholder: 'Event id',
    controls: false,
    rules: [
      { required: true, message: 'Event id is required' },
      { type: 'number', message: 'Event id must be a number.' },
    ],
  },
};
